import clsx from 'clsx';
import { Skeleton } from './Skeleton';

/**
 * SkeletonTable - Tablo sayfaları için skeleton
 * 
 * @param {number} rows - Satır sayısı
 * @param {number} columns - Sütun sayısı
 * @param {boolean} showHeader - Başlık satırı göster
 * @param {boolean} showRowNumbers - Satır numarası sütunu
 * @param {boolean} showPagination - Sayfalama göster
 */
export function SkeletonTable({
    rows = 10,
    columns = 6,
    showHeader = true,
    showRowNumbers = true,
    showPagination = true,
    className,
}) {
    const effectiveColumns = showRowNumbers ? columns + 1 : columns;

    return (
        <div className={clsx('overflow-hidden rounded-lg border border-border-light', className)}>
            <div className="overflow-x-auto">
                <table className="min-w-full">
                    {/* Header */}
                    {showHeader && (
                        <thead className="bg-bg-tertiary">
                            <tr>
                                {showRowNumbers && (
                                    <th className="px-3 py-3 w-12">
                                        <Skeleton variant="text" className="h-3 w-4 mx-auto" />
                                    </th>
                                )}
                                {Array.from({ length: columns }).map((_, i) => (
                                    <th key={i} className="px-4 py-3">
                                        <Skeleton
                                            variant="text"
                                            className={clsx(
                                                'h-3',
                                                i === 0 ? 'w-20' : i === columns - 1 ? 'w-12' : 'w-16'
                                            )}
                                        />
                                    </th>
                                ))}
                            </tr>
                        </thead>
                    )}

                    {/* Body */}
                    <tbody className="bg-bg-secondary divide-y divide-border-light">
                        {Array.from({ length: rows }).map((_, rowIndex) => (
                            <tr key={rowIndex}>
                                {showRowNumbers && (
                                    <td className="px-3 py-3 w-12 text-center">
                                        <Skeleton variant="text" className="h-4 w-4 mx-auto" />
                                    </td>
                                )}
                                {Array.from({ length: columns }).map((_, colIndex) => (
                                    <td key={colIndex} className="px-4 py-3">
                                        <Skeleton
                                            variant="text"
                                            className={clsx(
                                                'h-4',
                                                colIndex === 0 ? 'w-24' :
                                                    colIndex === columns - 1 ? 'w-16' :
                                                        'w-20'
                                            )}
                                        />
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Pagination */}
            {showPagination && (
                <div className="px-4 py-3 bg-bg-tertiary/50 border-t border-border-light flex items-center justify-between">
                    <Skeleton variant="text" className="h-3 w-32" />
                    <div className="flex items-center gap-2">
                        {[1, 2, 3, 4, 5].map((i) => (
                            <Skeleton key={i} variant="rounded" className="h-8 w-8" />
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}

/**
 * SkeletonTableRow - Tek satır skeleton (lazy loading için)
 */
export function SkeletonTableRow({ columns = 6, showRowNumbers = true }) {
    return (
        <tr>
            {showRowNumbers && (
                <td className="px-3 py-3 w-12 text-center">
                    <Skeleton variant="text" className="h-4 w-4 mx-auto" />
                </td>
            )}
            {Array.from({ length: columns }).map((_, i) => (
                <td key={i} className="px-4 py-3">
                    <Skeleton variant="text" className="h-4 w-20" />
                </td>
            ))}
        </tr>
    );
}

export default SkeletonTable;
